// Haversine formula to calculate distance between two GPS coordinates
function haversineDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * Calculate total distance from GeoJSON car path data
 * @param {Object} geoJsonData - GeoJSON FeatureCollection with LineString geometry
 * @returns {number} Total distance in kilometers
 */
export function calculateCarPathDistance(geoJsonData) {
  if (!geoJsonData || !geoJsonData.features || geoJsonData.features.length === 0) {
    return 0;
  }

  const coordinates = geoJsonData.features[0].geometry.coordinates;
  
  if (!coordinates || coordinates.length < 2) {
    return 0;
  }

  let totalDistance = 0;
  for (let i = 1; i < coordinates.length; i++) {
    const [lon1, lat1] = coordinates[i - 1];
    const [lon2, lat2] = coordinates[i];
    totalDistance += haversineDistance(lat1, lon1, lat2, lon2);
  }

  return totalDistance;
}

/**
 * Get first coordinate from GeoJSON car path data
 * @param {Object} geoJsonData - GeoJSON FeatureCollection with LineString geometry
 * @returns {Object} Object with lat and lon properties
 */
export function getFirstCoordinate(geoJsonData) {
  if (!geoJsonData || !geoJsonData.features || geoJsonData.features.length === 0) {
    return null;
  }

  const coordinates = geoJsonData.features[0].geometry.coordinates;
  
  if (!coordinates || coordinates.length === 0) {
    return null;
  }

  const [lon, lat] = coordinates[0];
  return { lat, lon };
}
